import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@karma/components';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import IconHappyCloud from 'components/atoms/IconHappyCloud/IconHappyCloud';
import useGetKarmaEarnRedirect from 'hooks/useGetKarmaEarnRedirect';

const ModalBodyKarmaEarnRedirectError = ({ closeModal, item }) => {
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const karmaEarnRedirect = useGetKarmaEarnRedirect(item);

  const clickHandler = () => {
    closeModal();
    karmaEarnRedirect();
  };

  return (
    <Stack direction="column">
      <IconHappyCloud width={145} height="auto" />
      <Typography variant="labelLarge" fontWeight={600} tMargin={20} bMargin={12}>
        {t('app:somethingWentWrong')}
      </Typography>
      <Button
        size="medium"
        fullWidth
        onClick={clickHandler}
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.TRY_AGAIN}
      >
        {t('app:tryAgain')}
      </Button>
    </Stack>
  );
};

export default ModalBodyKarmaEarnRedirectError;
